import http from '../../utils/http'
import { DASHBOARD_DRAFT_COUNT } from 'actions/dashboard'
import { AUTH_LOGOUT } from 'actions/authentication'
import Vue from 'vue'
import store from '@/store'

const state = {
	draftCount: JSON.parse(localStorage.getItem('draft-count')) || []
}

const getters = {
	getDraftCount: state => state.draftCount
}

const actions = {
	[DASHBOARD_DRAFT_COUNT]: ({ commit, dispatch }) => {
		return http.post('/items/draft-count')
			.then((resp) => {
				commit(DASHBOARD_DRAFT_COUNT, resp.data)
				return resp.data
			})
			.catch(err => {
				console.log(err)
				Vue.rollbar.error('DASHBOARD_DRAFT_COUNT', err)
			})
	}
}

const mutations = {
	[DASHBOARD_DRAFT_COUNT]: (state, resp) => {
		state.draftCount = resp
		localStorage.setItem('draft-count', JSON.stringify(resp))
	},
	[AUTH_LOGOUT]: state => {
		state.draftCount = []
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
